import { ADMIN_HOME } from '../../utils/HomeNavigation';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';

const PublicRoute = ({ children }) => {
  const { accessToken } = useContext(AuthContext);
  return accessToken ? <Navigate to={ADMIN_HOME} /> : children;
};

export default PublicRoute;
